import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Theme,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import DropdownInput from "common/components/DropdownInput";
import { useTranslation } from "common/locales";
import { GRASS_TYPE } from "model";

const PREFIX = "GrassTypeDropdown";

const classes = {
  formControl: `${PREFIX}-formControl`,
};

const StyledFormControl = styled(FormControl)(
  ({ theme }: { theme: Theme }) => ({
    [`&.${classes.formControl}`]: {
      maxWidth: 400,
      paddingBottom: theme.spacing(2),
    },
  })
);

interface GrassTypeDropdownProps {
  currentGrassType?: string;
  disabled: boolean;
  onChange: (value?: GRASS_TYPE) => void;
  grassTypeInputError: boolean;
  label: string;
}

export default function GrassTypeDropdown({
  disabled,
  onChange,
  currentGrassType,
  grassTypeInputError,
  label,
}: GrassTypeDropdownProps) {
  const { t } = useTranslation();

  return (
    <StyledFormControl
      className={classes.formControl}
      disabled={disabled}
      error={grassTypeInputError}
      fullWidth
    >
      <InputLabel
        id="assignedGroup-select-label"
        variant="standard"
        shrink={true}
        error={grassTypeInputError}
      >
        {t(label)}
      </InputLabel>
      <Select
        labelId="assignedGroup-select-label"
        id="assignedGroup-select"
        value={currentGrassType ?? ""}
        onChange={onChangeSelect}
        input={<DropdownInput />}
        error={grassTypeInputError}
      >
        {Object.entries(GRASS_TYPE).map(([key, value]) => (
          <MenuItem value={value} key={key}>
            {t(`fieldinput.grassType.option.${value}`)}
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );

  function onChangeSelect(e: SelectChangeEvent<string>) {
    onChange(e.target.value as GRASS_TYPE | undefined);
  }
}
